import { render } from "./CommonFooter.vue?vue&type=template&id=4a7b51d3"
const script = {}

import exportComponent from "E:\\docker\\sakae\\htdocs\\sakae-race-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__